var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_6653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9422 7.68291C18.0593 7.56571 18.1251 7.40681 18.1251 7.24112C18.1251 7.07543 18.0593 6.91652 17.9422 6.79932L13.2031 2.05791C13.0859 1.94079 12.927 1.875 12.7613 1.875C12.5956 1.875 12.4367 1.94079 12.3195 2.05791L7.84296 6.54698C7.84296 6.54698 5.675 5.46338 3.35937 7.33213C3.2907 7.3871 3.23441 7.45593 3.19417 7.53415C3.15394 7.61236 3.13066 7.69818 3.12587 7.78601C3.12107 7.87383 3.13487 7.96168 3.16636 8.04381C3.19785 8.12593 3.24631 8.20049 3.30859 8.2626L11.7383 16.6915C11.8014 16.7542 11.8772 16.8027 11.9606 16.8337C12.0439 16.8647 12.133 16.8776 12.2217 16.8715C12.3105 16.8653 12.3969 16.8403 12.4752 16.7981C12.5535 16.7559 12.6219 16.6974 12.6758 16.6267C13.3312 15.7548 14.3609 13.9634 13.4656 12.1735L17.9422 7.68291Z",
    stroke: "#808187",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52266 12.4775L3.75 16.2502",
    stroke: "#808187",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_6653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d533cf5f7e4f343538df5b19180c2761.svg";
export { ForwardRef as ReactComponent };